import { FileDocumentEditIcon } from './FileDocumentEditIcon';

/**
 * author: GreenTurtwig
 * id 83E06672-D36B-41FF-8463-080EB639F00F
 * name file-document-edit
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-edit.svg
 * tags
 * - Edit / Modify 
 * - Files / Folders 
 */
export const FileTextEditIcon = FileDocumentEditIcon;
export default FileTextEditIcon